import React, { Component } from "react";
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    Form,
    Label,
    Input,
    Button,
    Spinner,
    Alert
} from "reactstrap";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import config from "../../config/config";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import withRouter from "../../components/Common/withRouter";

class EditTour extends Component {
    constructor(props) {
        super(props);
        this.state = {
            breadcrumbItems: [
                { title: "Tours", link: "/tours" },
                { title: "Edit Tour", link: "#" },
            ],
            categories: [],
            trendingCategories: [],
            destinations: [],
            inclusions: [],
            exclusions: [],
            selectedCategory: "",
            selectedTourCategory: "",
            selectedTrendingCategory: "",
            selectedDestinations: [],
            selectedInclusions: [],
            selectedExclusions: [],
            dayWiseDescriptions: [{ day: 1, title: "", sightseeing_included: "", inclusion: "", activities: [{ text: "", image: null, imagePreview: null }] }],
            tourName: "",
            tourDescription: "",
            duration: "",
            price: "",
            priceBasis: "Per Person Twin Sharing",
            tourImage: null,
            imagePreview: null,
            existingImage: "",
            loading: true,
            error: null,
            submitting: false,
            errors: {},
        };
    }

    componentDidMount() {
        this.fetchCategories();
        this.fetchTrendingCategories();
        this.fetchInclusions();
        this.fetchExclusions();
        this.fetchDestinations();
    }

    // ✅ Fetch inclusions
    fetchInclusions = async () => {
        try {
            const res = await fetch(`${config.API_BASE_URL}/tourinclusions`);
            const data = await res.json();
            if (res.ok) {
                const inclusionOptions = data.map(inc => ({
                    value: inc.tourinclusion_name,
                    label: inc.tourinclusion_name
                }));
                this.setState({ inclusions: inclusionOptions });
            }
        } catch (err) {
            console.error("Error fetching inclusions:", err);
        }
    };

    // ✅ Fetch exclusions
    fetchExclusions = async () => {
        try {
            const res = await fetch(`${config.API_BASE_URL}/tourexclusions`);
            const data = await res.json();
            if (res.ok) {
                const exclusionOptions = data.map(exc => ({
                    value: exc.tourexclusion_name,
                    label: exc.tourexclusion_name
                }));
                this.setState({ exclusions: exclusionOptions });
            }
        } catch (err) {
            console.error("Error fetching exclusions:", err);
        }
    };

    // ✅ Fetch categories
    fetchCategories = async () => {
        try {
            const res = await fetch(`${config.API_BASE_URL}/categories`);
            const data = await res.json();
            if (res.ok) this.setState({ categories: data });
        } catch (err) {
            console.error("Error fetching categories:", err);
        }
    };

    // ✅ Fetch destinations (with _id)
    fetchDestinations = async () => {
        try {
            const res = await fetch(`${config.API_BASE_URL}/destinations`);
            const data = await res.json();
            if (res.ok) {
                const options = data.map(dest => ({
                    value: dest._id,
                    label: dest.destination_name
                }));
                this.setState({ destinations: options }, this.fetchTourData);
            }
        } catch (err) {
            console.error("Error fetching destinations:", err);
        }
    };

    // ✅ Fetch trending categories
    fetchTrendingCategories = async () => {
        try {
            const res = await fetch(`${config.API_BASE_URL}/trending-categories`);
            const data = await res.json();
            if (res.ok) {
                this.setState({ trendingCategories: data.data || data });
            }
        } catch (err) {
            console.error("Error fetching trending categories:", err);
        }
    };

    // ✅ Fetch tour data for editing
    fetchTourData = async () => {
        try {
            const tourId = this.props.router.params.id;
            const res = await fetch(`${config.API_BASE_URL}/tours/${tourId}`);
            const data = await res.json();

            if (res.ok) {
                // Map includes
                const inclusionOptions = (data.includes || []).map(inc => ({
                    value: inc,
                    label: inc
                }));

                // Map excludes
                const exclusionOptions = (data.excludes || []).map(exc => ({
                    value: exc,
                    label: exc
                }));

                // Match selected destination IDs with fetched destination options
                const matchedDestinations = (data.destinations || []).map(destId => {
                    const found = this.state.destinations.find(d => d.value === destId._id || d.value === destId);
                    return found || null;
                }).filter(Boolean);

                // Parse day-wise descriptions with activity images
                console.log("🔍 [EDIT] Raw dayWiseDescriptions from API:", JSON.stringify(data.dayWiseDescriptions, null, 2));
                
                const dayWiseDescriptions = data.dayWiseDescriptions && data.dayWiseDescriptions.length > 0
                    ? data.dayWiseDescriptions.map((day, dayIndex) => {
                        console.log(`🔍 [EDIT] Processing day ${dayIndex}:`, day);
                        return {
                            ...day,
                            activities: day.activities.map((activity, activityIndex) => {
                                console.log(`🔍 [EDIT] Processing activity ${activityIndex}:`, activity);
                                
                                if (typeof activity === 'string') {
                                    return { text: activity, image: null, imagePreview: null };
                                }
                                
                                const activityImage = activity.activity_image || activity.image || null;
                                console.log(`🔍 [EDIT] Activity image value:`, activityImage);
                                
                                // Check if activity_image is a placeholder (like "activity_0_0") or actual filename
                                const isPlaceholder = activityImage && activityImage.startsWith('activity_');
                                console.log(`🔍 [EDIT] Is placeholder:`, isPlaceholder);
                                
                                const parsedActivity = {
                                    text: activity.description || activity.text || activity,
                                    image: null,
                                    imagePreview: null,
                                    existingImage: isPlaceholder ? null : activityImage // Don't show placeholder as existing image
                                };
                                
                                console.log(`✅ [EDIT] Parsed activity for Day ${dayIndex}, Activity ${activityIndex}:`, parsedActivity);
                                return parsedActivity;
                            })
                        };
                    })
                    : [{ day: 1, title: "", activities: [{ text: "", image: null, imagePreview: null }] }];
                
                console.log("✅ [EDIT] Final dayWiseDescriptions state:", JSON.stringify(dayWiseDescriptions, null, 2));

                this.setState({
                    selectedCategory: data.category_name,
                    selectedTourCategory: data.tour_category || "",
                    selectedTrendingCategory: data.trendingCategoryId?._id || "",
                    selectedDestinations: matchedDestinations,
                    selectedInclusions: inclusionOptions,
                    selectedExclusions: exclusionOptions,
                    dayWiseDescriptions: dayWiseDescriptions,
                    tourName: data.tour_name,
                    tourDescription: data.description || "",
                    duration: data.duration,
                    price: data.price,
                    priceBasis: data.price_basis || "Per Person Twin Sharing",
                    existingImage: data.tour_image,
                    loading: false
                });
            } else {
                this.setState({ loading: false, error: "Failed to fetch tour data" });
            }
        } catch (err) {
            console.error("Error fetching tour data:", err);
            this.setState({ loading: false });
        }
    };

    handleInputChange = (e) => {
        const { name, value } = e.target;
        this.setState({ 
            [name]: value,
            errors: { ...this.state.errors, [name]: null }
        });
    };

    handleInclusionsChange = (selectedOptions) => {
        this.setState({ selectedInclusions: selectedOptions || [] });
    };

    handleExclusionsChange = (selectedOptions) => {
        this.setState({ selectedExclusions: selectedOptions || [] });
    };

    handleDestinationsChange = (selectedOptions) => {
        this.setState({ 
            selectedDestinations: selectedOptions || [],
            errors: { ...this.state.errors, selectedDestinations: null }
        });
    };

    handleDayTitleChange = (dayIndex, value) => {
        const updatedDays = [...this.state.dayWiseDescriptions];
        updatedDays[dayIndex].title = value;
        this.setState({ dayWiseDescriptions: updatedDays });
    };

    handleSightseeingChange = (dayIndex, value) => {
        const updatedDays = [...this.state.dayWiseDescriptions];
        updatedDays[dayIndex].sightseeing_included = value;
        this.setState({ dayWiseDescriptions: updatedDays });
    };

    handleDayInclusionChange = (dayIndex, value) => {
        const updatedDays = [...this.state.dayWiseDescriptions];
        updatedDays[dayIndex].inclusion = value;
        this.setState({ dayWiseDescriptions: updatedDays });
    };

    handleActivityChange = (dayIndex, activityIndex, value) => {
        const updatedDays = [...this.state.dayWiseDescriptions];
        updatedDays[dayIndex].activities[activityIndex].text = value;
        this.setState({ dayWiseDescriptions: updatedDays });
    };

    handleActivityImageChange = (dayIndex, activityIndex, file) => {
        console.log('🔍 [EDIT] handleActivityImageChange called:', { dayIndex, activityIndex, file });
        const updatedDays = [...this.state.dayWiseDescriptions];
        if (file) {
            console.log('✅ [EDIT] File selected:', file.name, file.size, file.type);
            updatedDays[dayIndex].activities[activityIndex].image = file;
            updatedDays[dayIndex].activities[activityIndex].imagePreview = URL.createObjectURL(file);
            updatedDays[dayIndex].activities[activityIndex].existingImage = null;
            console.log('✅ [EDIT] New image set, existing image cleared');
        } else {
            console.log('❌ [EDIT] No file selected, clearing new image');
            updatedDays[dayIndex].activities[activityIndex].image = null;
            updatedDays[dayIndex].activities[activityIndex].imagePreview = null;
        }
        this.setState({ dayWiseDescriptions: updatedDays }, () => {
            console.log('🔄 [EDIT] State updated - Activity:', this.state.dayWiseDescriptions[dayIndex].activities[activityIndex]);
            console.log('🔄 [EDIT] All activities with images:', 
                this.state.dayWiseDescriptions.map((day, dIdx) => 
                    day.activities.map((act, aIdx) => ({
                        day: dIdx,
                        activity: aIdx,
                        hasNewImage: !!act.image,
                        hasExistingImage: !!act.existingImage,
                        fileName: act.image?.name,
                        existingImageName: act.existingImage
                    }))
                ).flat()
            );
        });
    };

    addActivity = (dayIndex) => {
        const updatedDays = [...this.state.dayWiseDescriptions];
        updatedDays[dayIndex].activities.push({ text: "", image: null, imagePreview: null });
        this.setState({ dayWiseDescriptions: updatedDays });
    };

    removeActivity = (dayIndex, activityIndex) => {
        const updatedDays = [...this.state.dayWiseDescriptions];
        if (updatedDays[dayIndex].activities.length > 1) {
            updatedDays[dayIndex].activities.splice(activityIndex, 1);
            this.setState({ dayWiseDescriptions: updatedDays });
        }
    };

    addDay = () => {
        const newDay = {
            day: this.state.dayWiseDescriptions.length + 1,
            title: "",
            sightseeing_included: "",
            inclusion: "",
            activities: [{ text: "", image: null, imagePreview: null }],
        };
        this.setState({
            dayWiseDescriptions: [...this.state.dayWiseDescriptions, newDay],
        });
    };

    removeDay = (index) => {
        if (this.state.dayWiseDescriptions.length > 1) {
            const updatedDays = this.state.dayWiseDescriptions.filter((_, i) => i !== index);
            // Renumber days
            const renumberedDays = updatedDays.map((day, i) => ({ ...day, day: i + 1 }));
            this.setState({ dayWiseDescriptions: renumberedDays });
        }
    };

    handleCategoryChange = (e) => {
        this.setState({ 
            selectedCategory: e.target.value,
            errors: { ...this.state.errors, selectedCategory: null }
        });
    };

    handleTourCategoryChange = (e) => {
        this.setState({ 
            selectedTourCategory: e.target.value,
            errors: { ...this.state.errors, selectedTourCategory: null }
        });
    };

    handleTrendingCategoryChange = (e) => {
        this.setState({ selectedTrendingCategory: e.target.value });
    };

    handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            this.setState({
                tourImage: file,
                imagePreview: URL.createObjectURL(file),
                existingImage: ""
            });
        }
    };

    // ✅ Handle Submit
    validateForm = () => {
        const errors = {};
        
        if (!this.state.selectedCategory) {
            errors.selectedCategory = "Please select a State/Country Name";
        }
        
        if (!this.state.tourName.trim()) {
            errors.tourName = "Please enter a Tour Name";
        }
        
        if (!this.state.selectedDestinations || this.state.selectedDestinations.length === 0) {
            errors.selectedDestinations = "Please select at least one destination";
        }
        
        if (!this.state.tourDescription.trim()) {
            errors.tourDescription = "Please enter a tour description";
        }
        
        this.setState({ errors });
        return Object.keys(errors).length === 0;
    };

    handleSubmit = async (e) => {
        e.preventDefault();
        
        console.log("🚀 [EDIT] Form submission started");
        
        if (!this.validateForm()) {
            console.log("❌ [EDIT] Form validation failed");
            return;
        }
        
        this.setState({ submitting: true, errors: {} });

        try {
            const formData = new FormData();
            formData.append("category_name", this.state.selectedCategory);
            if (this.state.selectedTourCategory) {
                formData.append("tour_category", this.state.selectedTourCategory);
            }
            if (this.state.selectedTrendingCategory) {
                formData.append("trendingCategoryId", this.state.selectedTrendingCategory);
            }
            formData.append("tour_name", this.state.tourName);
            if (this.state.duration) {
                formData.append("duration", this.state.duration);
            }

            // ✅ Send destination IDs
            this.state.selectedDestinations.forEach(dest => {
                formData.append("destinations[]", dest.value);
            });

            if (this.state.price) {
                formData.append("price", this.state.price);
            }
            if (this.state.priceBasis) {
                formData.append("price_basis", this.state.priceBasis);
            }

            this.state.selectedInclusions.forEach(inc => {
                formData.append("includes[]", inc.value);
            });

            this.state.selectedExclusions.forEach(exc => {
                formData.append("excludes[]", exc.value);
            });

            // 🔍 Debug: Check activity images before processing
            console.log("🔍 [EDIT] Checking activity images before processing:");
            this.state.dayWiseDescriptions.forEach((day, dayIndex) => {
                day.activities.forEach((activity, activityIndex) => {
                    console.log(`[EDIT] Day ${dayIndex}, Activity ${activityIndex}:`, {
                        hasNewImage: !!activity.image,
                        hasExistingImage: !!activity.existingImage,
                        newFileName: activity.image?.name,
                        newFileSize: activity.image?.size,
                        existingImageName: activity.existingImage,
                        text: activity.text
                    });
                });
            });

            // Add day-wise descriptions with activity images (only if there's content)
            const hasValidDayWiseContent = this.state.dayWiseDescriptions.some(day => 
                day.title.trim() || day.activities.some(activity => activity.text.trim())
            );
            
            console.log("🔍 [EDIT] Has valid day-wise content:", hasValidDayWiseContent);
            
            if (hasValidDayWiseContent) {
                // Create dayWiseData structure and track activity images separately
                const dayWiseData = this.state.dayWiseDescriptions.map((day, dayIndex) => ({
                    day: day.day,
                    title: day.title,
                    sightseeing_included: day.sightseeing_included || "",
                    inclusion: day.inclusion || "",
                    activities: day.activities
                        .map((activity, activityIndex) => ({
                            description: (activity.text || "").trim(),
                            activity_image: activity.image 
                                ? `activity_${dayIndex}_${activityIndex}` 
                                : (activity.existingImage || null)
                        }))
                        .filter(act => act.description || act.activity_image)
                }));
                
                console.log("🔍 [EDIT] Day-wise data structure:", JSON.stringify(dayWiseData, null, 2));
                formData.append("dayWiseDescriptions", JSON.stringify(dayWiseData));
                
                // 🔍 Debug: Count activity images to be added
                let newActivityImageCount = 0;
                
                // Add new activity images as separate binary fields (like tour_image)
                this.state.dayWiseDescriptions.forEach((day, dayIndex) => {
                    day.activities.forEach((activity, activityIndex) => {
                        if (activity.image) {
                            const fieldName = `activity_${dayIndex}_${activityIndex}`;
                            console.log(`📎 [EDIT] Adding new activity image: ${fieldName}`, {
                                fileName: activity.image.name,
                                fileSize: activity.image.size,
                                fileType: activity.image.type
                            });
                            formData.append(fieldName, activity.image);
                            newActivityImageCount++;
                        }
                    });
                });
                
                console.log(`📊 [EDIT] Total new activity images added to FormData: ${newActivityImageCount}`);
            }

            formData.append("description", this.state.tourDescription);

            if (this.state.tourImage) {
                console.log("📎 [EDIT] Adding new tour image:", this.state.tourImage.name);
                formData.append("tour_image", this.state.tourImage);
            }

            // 🔍 Debug: Log FormData contents
            console.log("📋 [EDIT] FormData contents:");
            for (let [key, value] of formData.entries()) {
                if (value instanceof File) {
                    console.log(`${key}: [File] ${value.name} (${value.size} bytes, ${value.type})`);
                } else {
                    console.log(`${key}: ${value}`);
                }
            }

            const tourId = this.props.router.params.id;
            console.log("📤 [EDIT] Sending update request for tour ID:", tourId);
            
            const res = await fetch(`${config.API_BASE_URL}/tours/${tourId}`, {
                method: "PUT",
                body: formData,
            });

            const data = await res.json();

            if (res.ok) {
                console.log("✅ [EDIT] Tour updated successfully:", data);
                this.props.router.navigate("/tours");
            } else {
                console.error("❌ [EDIT] Failed to update tour:", data);
                this.setState({ 
                    errors: { submit: data.message || "Failed to update tour" },
                    submitting: false 
                });
            }
        } catch (err) {
            console.error("💥 [EDIT] Error updating tour:", err);
            this.setState({ 
                errors: { submit: "Error updating tour" },
                submitting: false 
            });
        }
    };

    handleCancel = () => {
        this.props.router.navigate("/tours");
    };

    render() {
        const { loading, error, existingImage, imagePreview, submitting } = this.state;

        if (loading) {
            return (
                <div className="page-content">
                    <Container fluid>
                        <div className="d-flex justify-content-center align-items-center" style={{ height: "50vh" }}>
                            <Spinner color="primary" />
                        </div>
                    </Container>
                </div>
            );
        }

        return (
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs title="Edit Tour" breadcrumbItems={this.state.breadcrumbItems} />

                    {error && <Alert color="danger" className="mb-3">{error}</Alert>}

                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardBody>
                                    <Form onSubmit={(e) => {
                                        console.log("🔍 [EDIT] Form onSubmit triggered!");
                                        this.handleSubmit(e);
                                    }}>
                                        <Row>
                                            {/* Category */}
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <Label className="form-label">State / Country Name <span className="text-danger">*</span></Label>
                                                    <Input 
                                                        type="select" 
                                                        value={this.state.selectedCategory} 
                                                        onChange={this.handleCategoryChange} 
                                                        required
                                                        className={this.state.errors.selectedCategory ? "is-invalid" : ""}
                                                    >
                                                        <option value="">Select State / Country Name</option>
                                                        {this.state.categories.map(cat => (
                                                            <option key={cat._id} value={cat.category_name}>{cat.category_name}</option>
                                                        ))}
                                                    </Input>
                                                    {this.state.errors.selectedCategory && (
                                                        <div className="invalid-feedback d-block">
                                                            {this.state.errors.selectedCategory}
                                                        </div>
                                                    )}
                                                </div>
                                            </Col>

                                            {/* Tour Category */}
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <Label className="form-label">Tour Category</Label>
                                                    <Input 
                                                        type="select" 
                                                        value={this.state.selectedTourCategory} 
                                                        onChange={this.handleTourCategoryChange}
                                                        className={this.state.errors.selectedTourCategory ? "is-invalid" : ""}
                                                    >
                                                        <option value="">Select Tour Category</option>
                                                        {this.state.categories.map(cat => (
                                                            <option key={`tour-cat-${cat._id}`} value={cat.category_name}>{cat.category_name}</option>
                                                        ))}
                                                    </Input>
                                                </div>
                                            </Col>

                                            {/* Trending Category */}
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <Label className="form-label">Trending Category</Label>
                                                    <Input type="select" value={this.state.selectedTrendingCategory} onChange={this.handleTrendingCategoryChange}>
                                                        <option value="">Select Trending Category</option>
                                                        {this.state.trendingCategories.map(tc => (
                                                            <option key={tc._id} value={tc._id}>{tc.name}</option>
                                                        ))}
                                                    </Input>
                                                </div>
                                            </Col>

                                            {/* Tour Name */}
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <Label className="form-label">Tour Name <span className="text-danger">*</span></Label>
                                                    <Input 
                                                        type="text" 
                                                        name="tourName" 
                                                        value={this.state.tourName} 
                                                        onChange={this.handleInputChange} 
                                                        required
                                                        className={this.state.errors.tourName ? "is-invalid" : ""}
                                                    />
                                                    {this.state.errors.tourName && (
                                                        <div className="invalid-feedback d-block">
                                                            {this.state.errors.tourName}
                                                        </div>
                                                    )}
                                                </div>
                                            </Col>

                                            {/* Duration */}
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <Label className="form-label">Duration</Label>
                                                    <Input type="text" name="duration" value={this.state.duration} onChange={this.handleInputChange} />
                                                </div>
                                            </Col>

                                            {/* Destinations */}
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <Label className="form-label">Destinations <span className="text-danger">*</span></Label>
                                                    <Select
                                                        isMulti
                                                        name="destinations"
                                                        options={this.state.destinations}
                                                        value={this.state.selectedDestinations}
                                                        onChange={this.handleDestinationsChange}
                                                        placeholder="Select destinations..."
                                                        classNamePrefix="react-select"
                                                        className={this.state.errors.selectedDestinations ? "is-invalid" : ""}
                                                    />
                                                    {this.state.errors.selectedDestinations && (
                                                        <div className="invalid-feedback d-block">
                                                            {this.state.errors.selectedDestinations}
                                                        </div>
                                                    )}
                                                </div>
                                            </Col>

                                            {/* Price */}
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <Label className="form-label">Price (INR)</Label>
                                                    <Input type="number" name="price" value={this.state.price} onChange={this.handleInputChange} />
                                                </div>
                                            </Col>

                                            {/* Price Basis */}
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <Label className="form-label">Price Basis</Label>
                                                    <Input type="select" name="priceBasis" value={this.state.priceBasis} onChange={this.handleInputChange}>
                                                        <option value="Per Person Twin Sharing">Per Person Twin Sharing</option>
                                                        <option value="Per Person Single Occupancy">Per Person Single Occupancy</option>
                                                        <option value="Per Couple">Per Couple</option>
                                                        <option value="Per Family">Per Family</option>
                                                    </Input>
                                                </div>
                                            </Col>

                                            {/* Inclusions */}
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <Label className="form-label">Includes</Label>
                                                    <Select
                                                        isMulti
                                                        name="includes"
                                                        options={this.state.inclusions}
                                                        value={this.state.selectedInclusions}
                                                        onChange={this.handleInclusionsChange}
                                                        placeholder="Select inclusions..."
                                                        classNamePrefix="react-select"
                                                    />
                                                </div>
                                            </Col>

                                            {/* Exclusions */}
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <Label className="form-label">Excludes</Label>
                                                    <Select
                                                        isMulti
                                                        name="excludes"
                                                        options={this.state.exclusions}
                                                        value={this.state.selectedExclusions}
                                                        onChange={this.handleExclusionsChange}
                                                        placeholder="Select exclusions..."
                                                        classNamePrefix="react-select"
                                                    />
                                                </div>
                                            </Col>

                                            {/* Description */}
                                            <Col md={12}>
                                                <div className="mb-3">
                                                    <Label className="form-label">Description <span className="text-danger">*</span></Label>
                                                    <Input 
                                                        type="textarea" 
                                                        name="tourDescription" 
                                                        value={this.state.tourDescription} 
                                                        onChange={this.handleInputChange} 
                                                        rows="5"
                                                        required
                                                        className={this.state.errors.tourDescription ? "is-invalid" : ""}
                                                    />
                                                    {this.state.errors.tourDescription && (
                                                        <div className="invalid-feedback d-block">
                                                            {this.state.errors.tourDescription}
                                                        </div>
                                                    )}
                                                </div>
                                            </Col>

                                            {/* Day-wise Descriptions */}
                                            <Col md={12}>
                                                <div className="mb-3">
                                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                                        <Label className="form-label mb-0">
                                                            <strong>Day-wise Itinerary</strong>
                                                        </Label>
                                                        <Button
                                                            type="button"
                                                            color="success"
                                                            size="sm"
                                                            onClick={this.addDay}
                                                        >
                                                            <i className="ri-add-line"></i> Add Day
                                                        </Button>
                                                    </div>
                                                    {this.state.dayWiseDescriptions.map((day, dayIndex) => (
                                                        <Card key={dayIndex} className="mb-3">
                                                            <CardBody>
                                                                <div className="d-flex justify-content-between align-items-center mb-3">
                                                                    <h5 className="mb-0">Day {day.day}</h5>
                                                                    {this.state.dayWiseDescriptions.length > 1 && (
                                                                        <Button
                                                                            type="button"
                                                                            color="danger"
                                                                            size="sm"
                                                                            onClick={() => this.removeDay(dayIndex)}
                                                                        >
                                                                            <i className="ri-delete-bin-line"></i> Remove Day
                                                                        </Button>
                                                                    )}
                                                                </div>
                                                                
                                                                {/* Day Title */}
                                                                <div className="mb-3">
                                                                    <Label className="form-label">Day Title</Label>
                                                                    <Input
                                                                        type="text"
                                                                        placeholder="e.g., ARRIVAL AT COCHIN AIRPORT/RAILWAYSTATION"
                                                                        value={day.title}
                                                                        onChange={(e) => this.handleDayTitleChange(dayIndex, e.target.value)}
                                                                    />
                                                                </div>

                                                                {/* Optional Day Fields */}
                                                                <Row className="mb-3">
                                                                    <Col md={6}>
                                                                        <Label className="form-label">Sight Seeing Included (Optional)</Label>
                                                                        <Input
                                                                            type="text"
                                                                            placeholder="e.g. Full day sightseeing of Port Blair"
                                                                            value={day.sightseeing_included || ""}
                                                                            onChange={(e) => this.handleSightseeingChange(dayIndex, e.target.value)}
                                                                        />
                                                                    </Col>
                                                                    <Col md={6}>
                                                                        <Label className="form-label">Inclusion (Optional)</Label>
                                                                        <Input
                                                                            type="select"
                                                                            value={day.inclusion || ""}
                                                                            onChange={(e) => this.handleDayInclusionChange(dayIndex, e.target.value)}
                                                                        >
                                                                            <option value="">Select Inclusion (Optional)</option>
                                                                            {this.state.inclusions && this.state.inclusions.map((inc, i) => (
                                                                                <option key={i} value={inc.value || inc.label || inc}>
                                                                                    {inc.label || inc.value || inc}
                                                                                </option>
                                                                            ))}
                                                                        </Input>
                                                                    </Col>
                                                                </Row>

                                                                {/* Activities */}
                                                                <div className="mb-2">
                                                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                                                        <Label className="form-label mb-0">Activities</Label>
                                                                        <Button
                                                                            type="button"
                                                                            color="info"
                                                                            size="sm"
                                                                            onClick={() => this.addActivity(dayIndex)}
                                                                        >
                                                                            <i className="ri-add-line"></i> Add Activity
                                                                        </Button>
                                                                    </div>
                                                                    {day.activities.map((activity, activityIndex) => (
                                                                        <div key={activityIndex} className="mb-3 border p-3 rounded">
                                                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                                                                <Label className="form-label mb-0">Activity {activityIndex + 1}</Label>
                                                                                {day.activities.length > 1 && (
                                                                                    <Button
                                                                                        type="button"
                                                                                        color="danger"
                                                                                        size="sm"
                                                                                        onClick={() => this.removeActivity(dayIndex, activityIndex)}
                                                                                    >
                                                                                        <i className="ri-close-line"></i> Remove
                                                                                    </Button>
                                                                                )}
                                                                            </div>
                                                                            
                                                                            <Row>
                                                                                <Col md={8}>
                                                                                    <Input
                                                                                        type="text"
                                                                                        placeholder={`Activity ${activityIndex + 1} description`}
                                                                                        value={activity.text}
                                                                                        onChange={(e) =>
                                                                                            this.handleActivityChange(dayIndex, activityIndex, e.target.value)
                                                                                        }
                                                                                    />
                                                                                </Col>
                                                                                <Col md={4}>
                                                                                    <Input
                                                                                        type="file"
                                                                                        accept="image/*"
                                                                                        onChange={(e) => {
                                                                                            console.log(`🔍 [EDIT] File input change for Day ${dayIndex}, Activity ${activityIndex}:`, e.target.files[0]);
                                                                                            this.handleActivityImageChange(dayIndex, activityIndex, e.target.files[0]);
                                                                                        }}
                                                                                    />
                                                                                </Col>
                                                                            </Row>
                                                                            
                                                                            {/* Show existing image if no new image is selected */}
                                                                            {activity.existingImage && !activity.imagePreview && (
                                                                                <Row className="mt-2">
                                                                                    <Col md={6}>
                                                                                        <p className="text-muted mb-1">Current image:</p>
                                                                                        <img
                                                                                            src={`${config.IMAGE_URL}/${activity.existingImage}`}
                                                                                            alt={`Activity ${activityIndex + 1}`}
                                                                                            className="img-fluid"
                                                                                            style={{ maxHeight: "150px" }}
                                                                                            onError={(e) => {
                                                                                                console.error('❌ [EDIT] Image failed to load:', `${config.IMAGE_URL}/${activity.existingImage}`);
                                                                                                e.target.style.display = 'none';
                                                                                                // Show error message
                                                                                                const errorMsg = e.target.nextSibling;
                                                                                                if (errorMsg) errorMsg.style.display = 'block';
                                                                                            }}
                                                                                            onLoad={() => {
                                                                                                console.log('✅ [EDIT] Image loaded successfully:', `${config.IMAGE_URL}/${activity.existingImage}`);
                                                                                            }}
                                                                                        />
                                                                                        <div style={{ display: 'none', color: 'red', marginTop: '5px' }}>
                                                                                            ⚠️ Image not found. Please upload a new image.
                                                                                        </div>
                                                                                    </Col>
                                                                                </Row>
                                                                            )}
                                                                            
                                                                            {/* Show message if no existing image */}
                                                                            {!activity.existingImage && !activity.imagePreview && (
                                                                                <Row className="mt-2">
                                                                                    <Col md={12}>
                                                                                        <small className="text-muted">
                                                                                            ℹ️ No image uploaded for this activity. Upload one using the file input above.
                                                                                        </small>
                                                                                    </Col>
                                                                                </Row>
                                                                            )}
                                                                            
                                                                            {/* Show new image preview */}
                                                                            {activity.imagePreview && (
                                                                                <Row className="mt-2">
                                                                                    <Col md={6}>
                                                                                        <p className="text-muted mb-1">New image preview:</p>
                                                                                        <img
                                                                                            src={activity.imagePreview}
                                                                                            alt={`Activity ${activityIndex + 1} preview`}
                                                                                            className="img-fluid"
                                                                                            style={{ maxHeight: "150px" }}
                                                                                        />
                                                                                    </Col>
                                                                                </Row>
                                                                            )}
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </CardBody>
                                                        </Card>
                                                    ))}
                                                </div>
                                            </Col>

                                            {/* Debug Button - Remove this after testing */}
                                            {/* <Col md={12}>
                                                <div className="mb-3">
                                                    <Button
                                                        type="button"
                                                        color="info"
                                                        size="sm"
                                                        onClick={() => {
                                                            console.log("🔍 [EDIT] DEBUG: Current activity images state:");
                                                            this.state.dayWiseDescriptions.forEach((day, dayIndex) => {
                                                                console.log(`Day ${dayIndex + 1} (${day.title}):`);
                                                                day.activities.forEach((activity, activityIndex) => {
                                                                    console.log(`  Activity ${activityIndex + 1}:`, {
                                                                        text: activity.text,
                                                                        hasNewImage: !!activity.image,
                                                                        hasExistingImage: !!activity.existingImage,
                                                                        newFileName: activity.image?.name,
                                                                        newFileSize: activity.image?.size,
                                                                        existingImageName: activity.existingImage,
                                                                        hasPreview: !!activity.imagePreview
                                                                    });
                                                                });
                                                            });
                                                        }}
                                                    >
                                                        🔍 Debug Activity Images State
                                                    </Button>
                                                </div>
                                            </Col> */}

                                            {/* Image */}
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <Label className="form-label">Tour Image</Label>
                                                    <Input type="file" onChange={this.handleImageChange} accept="image/*" />
                                                    {existingImage && !imagePreview && (
                                                        <img
                                                            src={`${config.IMAGE_URL}/${existingImage}`}
                                                            alt="Tour"
                                                            className="img-fluid mt-2"
                                                            style={{ maxHeight: "200px" }}
                                                        />
                                                    )}
                                                </div>
                                            </Col>
                                        </Row>

                                        {imagePreview && (
                                            <Row className="mt-3">
                                                <Col md={6}>
                                                    <p className="text-muted">New image preview:</p>
                                                    <img src={imagePreview} alt="Preview" className="img-fluid" style={{ maxHeight: "200px" }} />
                                                </Col>
                                            </Row>
                                        )}

                                        {/* Error Messages */}
                                        {this.state.errors.submit && (
                                            <Row className="mt-3">
                                                <Col md={12}>
                                                    <div className="alert alert-danger">
                                                        {this.state.errors.submit}
                                                    </div>
                                                </Col>
                                            </Row>
                                        )}

                                        <Row className="mt-4">
                                            <Col className="d-flex justify-content-end">
                                                <Button type="submit" color="primary" disabled={submitting}>
                                                    {submitting ? <Spinner size="sm" /> : "Update Tour"}
                                                </Button>
                                                <Button type="button" color="secondary" onClick={this.handleCancel} disabled={submitting} className="ms-2">
                                                    Cancel
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Form>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}

export default withRouter(EditTour);
